/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getCommodityList, getMilestoneConfigCommodity } from '../../store/Commodity/actions';
import { getNameClient } from './../../helpers/nameClient';
//redux
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import usePageTitle from '../../common/hooks/usePageTitle';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import { getDynamicAttrUpdated, getDynamicFilterCF, transformCFColumnsData } from '../../helpers/tools_helper';
import { cancelFetchCommodity } from '../../store/Commodity/saga';
import IForm from '../salesOrderList/iForm';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';

const Commodity = (props: any) => {
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [title, setTitle] = useState('');
    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });
    const groupName = 'commodityViewList';

    const PageTitleCO = usePageTitle(props.location.pathname);

    const [CommodityList, setCommodityList] = useState<any[]>([]);
    const [tableConfig, setTableConfig] = useState([]);
    const dispatch = useDispatch();

    const { data, isLoading, milestoneConfig, CountItems } = useSelector((state: any) => state.Commodity);
    const currentDate = new Date();

    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'CLEntryDate' : 'ASC'}",
        dynamicFilter: '',
        dynamicFilterCF: '',
    });

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
        const visibleInModalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => {
            return x.value;
        });
        setTitle(titleArr.join(' - '));
    };

    useEffect(() => {
        dispatch(getMilestoneConfigCommodity());
    }, []);

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(data);
        setCommodityList(listFinal);
    }, [data]);

    useEffect(() => {
        if (isFirstRun) {
          const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if (filters[groupName]) {
            handleActionOnSearch(filters[groupName]);
          }
          setIsFirstRun(false);
        } else {
          dispatch(getCommodityList({ form, pagination }));
        }
      }, [dispatch, form, pagination, isFirstRun]);


      useEffect(() => {
        if (!milestoneConfig || milestoneConfig.length === 0) {
            setTableConfig([]); // Handle null or empty milestoneConfig
            return;
        }
        const dataSorted = milestoneConfig.sort((a: any, b: any) => {
            const x = a.order;
            const y = b.order;
            return x > y ? 1 : x < y ? -1 : 0;
        });    
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
        });
        setTableConfig(dataSorted);
    }, [milestoneConfig]);

    

    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const getFilterCF = getDynamicFilterCF(data);
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        const newForm = { ...data, order: form.order, dynamicFilter: filterString, dynamicFilterCF: getFilterCF };
        setForm(newForm);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({ ...form, order: `{'${sortField ?? 'CLEntryDate'}' : '${sortOrder.toUpperCase()}'}` });
    };
    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const processList = (list: any[], selectedRow: any) => {
        return list.map((data) => ({
            ...data,
            value: selectedRow[data.dataField] || null,
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="pageContent">
                    <PageTitle>
                        <title>
                            {PageTitleCO.replace(/-/g, ' ')} | {getNameClient()}
                        </title>
                    </PageTitle>
                    <Container fluid>
                        <Row>
                            <Filters onSearchClicked={handleActionOnSearch} filterItems={milestoneConfig} groupName={groupName} />
                        </Row>
                        <Row>
                            <div className="container">
                                <Iloading cancelFetch={cancelFetchCommodity} loading={isLoading}/>
                            </div>
                            {CommodityList?.length > 0 ? (
                                milestoneConfig.length === 0 ? (
                                    <>
                                        <div>No config operations for this table</div>
                                    </>
                                ) : (
                                    <>
                                        <ITable
                                            remote={true}
                                            CountItems={CountItems}
                                            handlerPaginationState={handlePaginationChange}
                                            data={CommodityList}
                                            fields={milestoneConfig}
                                            tableColumns={milestoneConfig}
                                            headerColorT={'bg-primary text-white'}
                                            groupName={groupName}
                                            handlePopUpState={onPopUpState}
                                            actionOnRowClick={handleActionOnRowClick}
                                            handleTableSort={handleTableSort}
                                        />
                                    </>
                                )
                            ) : (
                                <div style={{ height: 180 }} />
                            )}
                        </Row>
                    </Container>
                </div>
                <IPopUp
                    stateAdd={popUpState}
                    switchStateAdd={setpopUpState}
                    stateUpdate={updateState}
                    switchStateUpdate={setUpdateState}
                    modalTitleAdd={title}
                    modaleTitleUpdate={'Commodity'}
                    icon="shopping-bag"
                    colorHeaderPop={'#101340'}
                >
                    <IForm selectedRow={selectedRow} milestoneConfig={tableConfig} groupName={groupName} />
                </IPopUp>
            </div>
        </React.Fragment>
    );
};

export default Commodity;
